import React from "react";
import { LeadDetailView } from "../../../components/LeadDetailView";
import { useAdminAuth } from "../../auth/AdminAuthContext";
import { useParams } from "react-router";

export function ExhibitorYouScannedDetailPage() {
  const { user } = useAdminAuth();
  const { id } = useParams();
  const eventId = user?.assignedEventId ?? "";

  if (!eventId || !id) {
    return <div className="p-6 text-gray-500">Лид не найден</div>;
  }

  return <LeadDetailView eventId={eventId} leadId={id} audience="admin" />;
}
